const Div = ({ children, className, ...others }) => {
  return (
    <div
      className={`px-4 sm:px-6 xl:px-8 py-4 dark:bg-custom_black bg-dark_primary_label ${className}`}
      {...others}
    >
      {children}
    </div>
  );
};

export default Div;
